export default __webpack_public_path__ + "static/media/ballons.e8c64193.svg";